import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import logo from '../assets/logo192.png'; // Import the logo image

const LogoContainer = styled(Box)(({ theme }) => ({
  height: '32px',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5) // Add some space between logo image and text
}));

// Removed ArchitecturalBar component

const CompanyName = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 'bold',
  letterSpacing: 'tight',
  color: theme.palette.mode === 'dark' ? '#00CED1' : '#005082'
}));

const BetaTag = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 'normal',
  color: '#CD5C5C',
  marginLeft: '4px',
  verticalAlign: 'top',
  display: 'inline-block'
}));

export const Logo = ({ onClick }) => {
  return (
    <LogoContainer>
      <Link
        to="/"
        style={{ 
          display: 'flex',
          alignItems: 'center',
          padding: '4px',
          borderRadius: '2px',
          textDecoration: 'none'
        }}
        onClick={onClick}
      >
        {/* Use the PNG logo image */}
        <img 
          src={logo} 
          alt="SANALYAPI Logo" 
          style={{ 
            height: '84px', 
            width: 'auto',
            display: 'block' 
          }} 
        />
          
        <CompanyName variant="h1" component="h1">
          SANALYAPI
            <BetaTag component="span">
              BETA
            </BetaTag>
          </CompanyName>
        {/* SVG is now directly inside the Link */}
      </Link>
    </LogoContainer>
  );
};
